import { VoucherEntity } from '@citydeals/category';

export class LoginInModalAction {
  static type = '[AUTH] Login in modal';

  constructor(readonly bookmark?: VoucherEntity) {}
}
